import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./HTMLEmbed.module.scss";
export const HTMLEmbed: React.FC<{
  code: string;
  grayscale?: boolean;
  fullwidth?: boolean;
}> = t0 => {
  const $ = _c(8);
  const {
    code,
    grayscale,
    fullwidth
  } = t0;
  let classNames;
  if ($[0] !== fullwidth || $[1] !== grayscale) {
    classNames = [styles.wrapper];
    if (grayscale) {
      classNames.push(styles.grayscale);
    }
    if (fullwidth) {
      classNames.push(styles.fullwidth);
    }
    $[0] = fullwidth;
    $[1] = grayscale;
    $[2] = classNames;
  } else {
    classNames = $[2];
  }
  const t1 = classNames.join(" ");
  let t2;
  if ($[3] !== code) {
    t2 = {
      __html: code
    };
    $[3] = code;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className={t1} dangerouslySetInnerHTML={t2} />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};